import { NocApiClient } from '@nocowanie/noc-api';

import { environment } from '@app/environments/environment';

export const sharedNocApiClient = new NocApiClient({
    BASE: environment.NOC_API_END_POINT,
});
